import LayoutAdmin from "@/layouts/layoutAdmin.vue";
import Dashboard from "@/views/module/employeeBenefitFunds/Dashboard.vue";
import Settings from "@/views/module/employeeBenefitFunds/Settings.vue";
import Accounts from "@/views/module/employeeBenefitFunds/Accounts.vue";
import Vouchers from "@/views/module/employeeBenefitFunds/Vouchers.vue";
import PayrollTransfers from "@/views/module/employeeBenefitFunds/PayrollTransfers.vue";
import GratuityDeposits from "@/views/module/employeeBenefitFunds/GratuityDeposits.vue";
import Claims from "@/views/module/employeeBenefitFunds/Claims.vue";
import FundReports from "@/views/module/employeeBenefitFunds/FundReports.vue";
import "@/views/module/employeeBenefitFunds/employeeBenefitFunds.css";

const reportRoute = (path, name, breadcrumb, ebfReport) => ({
  path,
  name,
  component: FundReports,
  meta: {
    breadcrumb: ["Employee Benefit Funds", "Reports", breadcrumb],
    ebfReport,
  },
});

export default [
  {
    path: "/employee-benefit-funds",
    name: "employee-benefit-funds",
    component: LayoutAdmin,
    meta: {
      UserLoggedIn: true,
      breadcrumb: "Employee Benefit Funds",
    },
    children: [
      {
        path: "dashboard",
        name: "ebf-dashboard",
        component: Dashboard,
        meta: { breadcrumb: ["Employee Benefit Funds", "Fund Dashboard"] },
      },
      {
        path: "settings",
        name: "ebf-settings",
        component: Settings,
        meta: { breadcrumb: ["Employee Benefit Funds", "Fund Settings"] },
      },
      {
        path: "accounts",
        name: "ebf-accounts",
        component: Accounts,
        meta: { breadcrumb: ["Employee Benefit Funds", "Fund Accounts"] },
      },
      {
        path: "vouchers",
        name: "ebf-vouchers",
        component: Vouchers,
        meta: { breadcrumb: ["Employee Benefit Funds", "Fund Operations", "Fund Vouchers"] },
      },
      {
        path: "payroll-transfers",
        name: "ebf-payroll-transfers",
        component: PayrollTransfers,
        meta: { breadcrumb: ["Employee Benefit Funds", "Fund Operations", "Payroll Transfers"] },
      },
      {
        path: "gratuity-deposits",
        name: "ebf-gratuity-deposits",
        component: GratuityDeposits,
        meta: { breadcrumb: ["Employee Benefit Funds", "Fund Operations", "Gratuity Deposits"] },
      },
      {
        path: "claims",
        name: "ebf-claims",
        component: Claims,
        meta: { breadcrumb: ["Employee Benefit Funds", "Fund Operations", "Benefit Claims"] },
      },
      reportRoute("reportsManagement/fund-summary", "ebf-report-fund-summary", "Fund Summary", "fund-summary"),
      reportRoute("reportsManagement/pf-contributions", "ebf-report-pf-contributions", "PF Contributions", "pf-contributions"),
      reportRoute("reportsManagement/payroll-transfers", "ebf-report-payroll-transfers", "Payroll Transfer Report", "payroll-transfers"),
      reportRoute("reportsManagement/gratuity-fund", "ebf-report-gratuity-fund", "Gratuity Fund Report", "gratuity-fund"),
      reportRoute("reportsManagement/employee-loans", "ebf-report-employee-loans", "Employee Loan Report", "employee-loans"),
      reportRoute("reportsManagement/claims", "ebf-report-claims", "Benefit Claim Report", "claims"),
      reportRoute("reportsManagement/voucher-register", "ebf-report-voucher-register", "Voucher Register", "voucher-register"),
      reportRoute("reportsManagement/fund-cash-book", "ebf-report-fund-cash-book", "Fund Cash Book", "fund-cash-book"),
      reportRoute("reportsManagement/trial-balance", "ebf-report-trial-balance", "Trial Balance", "trial-balance"),
      reportRoute("reportsManagement/employee-statement", "ebf-report-employee-statement", "Employee Statement", "employee-statement"),
    ],
  },
];
